<template>
  <div />
</template>

<script>
import AuthService from '@/common/services/Auth';
import { setupStyling } from '@samknows/utils';

export default {
  mounted() {
    AuthService.deauthenticate();
    const isAccountMigrated = this.$route.query.accountMigrated === 'true';
    this.$router.push(
      `/login${isAccountMigrated ? '?accountMigrated=true' : ''}`
    );
    setupStyling();
  }
};
</script>
